import React from 'react';
import bannerBg from '../assets/img/page-banner.jpg';
import Footer2 from '../components/Footer2';
import Header3 from '../components/Header3';
import PageBanner from '../components/PageBanner';
import ProjectFilter from '../components/ProjectFilter';

function Projects() {
    return (
        <>
            <Header3 />
            <PageBanner bannerBg={bannerBg} heading="Our Gallery" currentPage="Gallery" />
            <ProjectFilter />
            <Footer2 />
        </>
    );
}

export default Projects;
